export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-switch/index.js